import React from 'react';

import { Flex } from '@chakra-ui/react';

import { primaryDrawerWidth } from 'uiToolkitV1/BottomDrawer';

import { useCompetencyDrawerState } from '../competencyDrawerSlice';
import { PrimaryDrawerScreens } from '../types/slice';
import { CompetencyDrawerPanel } from './CompetencyDrawerPanel';
import { RequestFeedbackPanel } from './RequestFeedbackPanel';
import { ShareFeedbackPanel } from './ShareFeedbackPanel';

const PrimaryScreenMap: Record<PrimaryDrawerScreens, React.FC> = {
  COMPETENCY: CompetencyDrawerPanel,
  REQUEST_FEEDBACK: RequestFeedbackPanel,
  SHARE_FEEDBACK: ShareFeedbackPanel,
};

export const PrimaryPanelBody = () => {
  const { isSecondaryPanelOpen, selectedPrimaryScreen } = useCompetencyDrawerState();

  const Component = PrimaryScreenMap[selectedPrimaryScreen];

  return (
    <Flex
      flexDir="column"
      h="100%"
      width={`${primaryDrawerWidth}px`}
      pointerEvents={isSecondaryPanelOpen ? 'none' : 'auto'}
      opacity={isSecondaryPanelOpen ? 0.5 : 1}
    >
      {Component ? <Component /> : null}
    </Flex>
  );
};
